import React from "react"
import {
	PropsWithChildren,
	createContext,
	useContext,
	useMemo,
	useState,
} from "react";

import { localStorage } from "../helpers/localStorage";

export type AuthProviderTypes = {
	isAuthenticated: boolean;
	authToken: () => Promise<boolean | undefined>;
	userName: string;
	userInitials: string;
	handleLogin: () => void;
	handleLogout: () => void;
	authorizationToken: () => void;
	token: string;
	setAuthToken:  (value: any) => void;
};

const AuthContext = createContext<AuthProviderTypes>({} as AuthProviderTypes);

export function useAuth() {
	return useContext(AuthContext);
}

type Props = {};

export const AuthProvider = (props: PropsWithChildren<Props>) => {
	const {getAuthToken} = localStorage;

	const [userName, setUserName] = useState<string>("");
	const [userInitials, setUserInitials] = useState<string>("");
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
	const [token, setToken] = useState<string>("");
	

	const authorizationToken = async () => {
		try {
			const value = await getAuthToken();

			if (value !== null) {
				setToken(value);
				return true;
			} else {
				setIsAuthenticated(false);
				return false;
			}
		} catch (error) {
			console.log("Error retrieving value in auth provider:", error);
		}
	};

	const authToken = async () => {
		try {
			const value = await getAuthToken();

			if (value !== null) {
				setToken(value);
				return true;
			} else {
				setIsAuthenticated(false);
				return false;
			}
		} catch (error) {
			console.log("Error retrieving value in auth provider:", error);
		}
	};

	const handleLogin = () => {
		setIsAuthenticated(true);
	};

	const handleLogout = () => {
		setIsAuthenticated(false);
	};

	const setAuthToken = (value : any) => {
		setToken(value);
	};

	const value = useMemo(
		() => ({
			isAuthenticated: isAuthenticated,
			authToken,
			userName,
			userInitials,
			handleLogin,
			handleLogout,
			token,
			authorizationToken,
			setAuthToken,
		}),
		[isAuthenticated, userName, userInitials, authToken, handleLogin, handleLogout, token, authorizationToken, setAuthToken]
	);

	return (
        <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
	);
};

export default AuthProvider;
